import Team from "../schemas/Team";
import { team, manager, keeper } from "./stringConstants";
import { nanoid } from "nanoid";

export const allTeams: Team[] = [
  {
    id: nanoid(),
    teamName: [team.phxBastards],
    manager: [manager.yevgeny],
    teamLogo: "../phx.jpg",
    rankings: [1, 2, 3, 2, 1, 6, 6, 5, 3, 7, 3, 2, 8, 2, 7, 5],
    initialFranchisePlayers: [
      "Steve Nash, Jason Richardson, Grant Hill, Channing Frye, Amar'e Stoudemire, Leandro Barbosa",
      "Steve Nash, Jason Richardson, Hedo Turkoglu, Robin Lopez",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Steve Nash",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Markieff Morris",
        aquiredVia: "הרמת פרי אייג'נט מאוחרת",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Marcin Gortat",
        aquiredVia: "טרייד",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Eric Bledsoe",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 4,
      },
      {
        id: nanoid(),
        name: "Devin Booker",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 7,
      },
    ],
    draftPositions: [11, 11, 9, 9, 10, 11, 6, 6, 7, 2, 5, 9, 10, 4, 9, 5],
    vetDraftPos: [8, 5, 8, 3, 7, 8, 4, 8, 3],
    headerColors: {
      backgroundColor: "#3B024A",
      color: "#C44A0A",
    },
    currentKeepers: [
      {name: "Devin Booker", picUrl: "../booker.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Alperen Sengun", picUrl: "../sengun.png", onHover: "קיפר חופשי"},
      {name: "Pascal Siakam", picUrl: "../siakam.png", onHover: "קיפר חופשי"},
      {name: "Amen Thompson", picUrl: "../amen.png", onHover: "סליפר שנה שלישית"},
      {name: "Scoot Henderson", picUrl: "../scoot.png", onHover: "סליפר שנה שלישית"},
      {name: "Bub Carrington", picUrl: "../bub.png", onHover: "סליפר סופמור"},
    ]
  },
  {
    id: nanoid(),
    teamName: [team.domHawks],
    manager: [manager.dom],
    teamLogo: "../dom.jpg",
    rankings: [2, 8, 9, 9, 8, 2, 3, 10, 11, 8, 5, 3, 6, 6, 8, 6],
    initialFranchisePlayers: [
      "Mike Bibby, Joe Johnson, Marvin Williams, Josh Smith, Al Horford, Jamal Crawford",
      "Joe Johnson, Josh Smith, Al Horford, Jamal Crawford",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Josh Smith",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Paul Millsap",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 4,
      },
      {
        id: nanoid(),
        name: "Taurean Prince",
        aquiredVia: "טרייד",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "John Collins",
        aquiredVia: "טרייד",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Trae Young",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 2,
      },
    ],
    draftPositions: [8, 10, 4, 2, 3, 4, 10, 9, 2, 1, 4, 7, 9, 6, 5, 4],
    vetDraftPos: [7, 10, 11, 4, 1, 7, 2, 3, 4],
    headerColors: {
      backgroundColor: "#6E6D4C",
      color: "#090708",
    },
    currentKeepers: [
      {name: "Trae Young", picUrl: "../trae.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Jaren Jackson Jr", picUrl: "../jjj.png", onHover: "קיפר חופשי"},
      {name: "Donovan Mitchell", picUrl: "../mitchell.png", onHover: "קיפר חופשי"},
      {name: "Zaccharie Risacher", picUrl: "../miller.png", onHover: "סליפר סופמור"},
      {name: "Jared McCain", picUrl: "../mccain.png", onHover: "סליפר סופמור"},
      {name: "Derek Lively", picUrl: "../lively.png", onHover: keeper.yearThree}
    ]
  },
  {
    id: nanoid(),
    teamName: [team.bMovieBlazers],
    manager: [manager.nissim],
    teamLogo: "../por.jpg",
    rankings: [3, 3, 5, 7, 3, 5, 5, 4, 3, 4, 1, 7, 1, 1, 3, 6],
    initialFranchisePlayers: [
      "Andre Miller, Brandon Roy, Travis Outlaw, LaMarcus Aldridge, Rudy Fernandez",
      "Steve Blake, Brandon Roy, LaMarcus Aldridge, Rudy Fernandez",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "LaMarcus Aldridge",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 5,
      },
      {
        id: nanoid(),
        name: "Damian Lillard",
        aquiredVia: "טרייד",
        tenure: 9,
      },
    ],
    draftPositions: [6, 9, 8, 6, 5, 9, 7, 7, 8, 8, 8, 11, 5, 11, 11, 9],
    vetDraftPos: [5, 8, 7, 6, 9, 3, 9, 9, 7],
    headerColors: {
      backgroundColor: "#BB2322",
      color: "#0D0802",
    },
    currentKeepers: [
      {name: "Anfernee Simons", picUrl: "../anfernee.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Luka Doncic", picUrl: "../luka.png", onHover: "קיפר חופשי"},
      {name: "Jayson Tatum", picUrl: "../tatum.png", onHover: "קיפר חופשי"},
      {name: "Evan Mobley", picUrl: "../mobley.png", onHover: "שחקן השבחה"},
      {name: "Shaedon Sharpe", picUrl: "../sharpe.png", onHover: "סליפר עונה שלישית"},
      {name: "Chet Holmgren", picUrl: "../chet.png", onHover: "סליפר סופמור"}
    ]
  },
  {
    id: nanoid(),
    teamName: [team.philoozers, "Trust The Process"],
    manager: [manager.itay],
    teamLogo: "../phi.png",
    rankings: [4, 4, 10, 3, 5, 9, 8, 11, 7, 5, 6, 6, 11, 11, 4, 8],
    initialFranchisePlayers: [
      "Lou Williams, Andre Iguodala, Thaddeus Young, Elton Brand, Samuel Dalembert, Marreese Speights",
      "Lou Williams, Andre Iguodala, Elton Brand, Samuel Dalembert",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Andre Iguodala",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Evan Turner",
        aquiredVia: "נבחר כרוקי בבחירה 34 והוחזק מאז",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Thaddeus Young",
        aquiredVia: "דראפט, בחירה 14",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Nerlens Noel",
        aquiredVia: "הרמת פרי אייג'נט כרוקי פצוע",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Robert Covington",
        aquiredVia: "הרמת ווייבר וכעבור שנה בטרייד עם מתי",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "JJ Redick",
        aquiredVia: "טרייד עם מתי",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Joel Embiid",
        aquiredVia: "עסקת בלוקבאסטר עם אריאל ומתי",
        tenure: 5,
      },
    ],
    draftPositions: [3, 8, 7, 1, 9, 7, 3, 2, 1, 5, 7, 6, 6, 1, 1, 8],
    vetDraftPos: [2, 11, 2, 1, 2, 2, 11, 11, 6],
    headerColors: {
      backgroundColor: "#FFDE66",
      color: "#414A8B"
    },
    currentKeepers: [
      {name: "Joel Embiid", picUrl: "../embiid.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Paul George", picUrl: "../george.png", onHover: "קיפר חופשי וגיבוי למשבצת פרנצ'ייז"},
      {name: "Julius Randle", picUrl: "../randle.png", onHover: "קיפר חופשי"},
      {name: "Victor Wembenyama", picUrl: "../wemby.png", onHover: "סליפר סופמור"},
      {name: "Paolo Banchero", picUrl: "../paolo.png", onHover: "סליפר סופמור"},
      {name: "Adem Bona", picUrl: "../bona.png", onHover: "סליפר רוקי"}
    ]
  },
  {
    id: nanoid(),
    teamName: [
      team.bknNets,
      "Brooklyn Durnats",
      "Brook-Lin Durniets",
      "RH Nets",
      "Nets In Transition",
      "Indy Studs",
      "Indy Halicopters",
    ],
    manager: [manager.mati],
    teamLogo: "../ind.png",
    rankings: [9, 12, 1, 6, 7, 11, 7, 2, 9, 11, 4, 5, 4, 2, 6, 1],
    initialFranchisePlayers: [
      "Devin Harris, Courtney Lee, Terrence Williams, Yi Jianlian, Brook Lopez, Chris Douglas-Roberts",
      "Devin Harris, Terrence Williams, Yi Jianlian, Brook Lopez",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Kris Humphries",
        aquiredVia: "ווייברס",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Joe Johnson",
        aquiredVia: "בחירת סוף סיבוב ראשון",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Brook Lopez",
        aquiredVia: "הורם כפרי אייג'נט פצוע",
        tenure: 4,
      },
      {
        id: nanoid(),
        name: "Rondae Hollis-Jefferson",
        aquiredVia: "הובא בטרייד לשמש כשחקן פרנצ'ייז יוצא",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Victor Oldaipo",
        aquiredVia: "בחירה 13 בדראפט שלפני עונת הפריצה",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Domantas Sabonis",
        aquiredVia: "הורם בתחילת עונת הסופמור",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Myles Turner",
        aquiredVia: "טרייד על סליפר עודף (טריי מרפי)",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Tyrese Haliburton",
        aquiredVia: "צורף כרוקי בטרייד על באם",
        tenure: 1,
      },
    ],
    draftPositions: [5, 3, 2, 11, 6, 5, 1, 5, 13, 3, 1, 8, 7, 8, 13, 2],
    vetDraftPos: [3, 6, 1, 11, 6, 1, 6, 7, 2],
    didRelocate: true,
    headerColors: {
      backgroundColor: "#072556",
      color: "#FED66B",
    },
    currentKeepers: [
      {name: "Tyrese Haliburton", picUrl: "../hali.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Kevin Durant", picUrl: "../kd.png", onHover: "קיפר חופשי"},
      {name: "Dyson Daniels", picUrl: "../dyson.png", onHover: "קיפר חופשי"},
      {name: "Jalen Williams", picUrl: "../j-dub.png", onHover: "שחקן השבחה"},
      {name: "Brice Sensabaugh", picUrl: "../sensi.png", onHover: "סליפר שנה שלישית"},
      {name: "Bilal Coulibaly", picUrl: "../bilal.png", onHover: "סליפר שנה שלישית"}
    ]
  },
  {
    id: nanoid(),
    teamName: [
      team.detJews,
      "TheBrogdon's",
      "The NotBrogdon's",
      "The Motor Cades",
    ],
    manager: [manager.kobe],
    teamLogo: "../det.jpg",
    rankings: [8, 13, 7, 10, 6, 4, 9, 6, 3, 10, 7, 11, 7, 7, 9, 8],
    initialFranchisePlayers: [
      "Rodney Stuckey, Ben Gordon, Rip Hamilton, Tayshaun Prince, Charlie Villanueva, Will Bynum",
      "Rodney Stuckey, Ben Gordon, Tayshaun Prince, Will Bynum",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Rodney Stuckey",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Greg Monroe",
        aquiredVia: "הורם כרוקי והוחזק עד לקידום",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Reggie Jackson",
        aquiredVia: "טרייד",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Andre Drummond",
        aquiredVia: "נבחר כרוקי בסיבוב הרביעי",
        tenure: 5,
      },
      {
        id: nanoid(),
        name: "Jerami Grant",
        aquiredVia: "טרייד",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Cade Cunningham",
        aquiredVia: "נבחר ראשון בדראפט כרוקי",
        tenure: 1,
      },
    ],
    draftPositions: [1, 4, 1, 4, 2, 6, 8, 1, 6, 9, 2, 5, 1, 5, 4, 3],
    vetDraftPos: [1, 3, 5, 10, 3, 11, 3, 4, 5],
    headerColors: {
      backgroundColor: "#EC164A",
      color: "#FBFCFA",
    },
    currentKeepers: [
      {name: "Cade Cunningham", picUrl: "../cade.png", onHover: "שחקן פרנצ'ייז"},
      
      {name: "Giannis", picUrl: "../giannis.png", onHover: "קיפר חופשי"},
      {name: "Jalen Brunson", picUrl: "../brunson.png", onHover: "קיפר חופשי"},
      
      {name: "Jalen Duren", picUrl: "../duren.png", onHover: "שחקן השבחה"},
      {name: "Ron Holland", picUrl: "../holland.png", onHover: "סליפר סופמור"},
      {name: "Chaz Lanier", picUrl: "../chaz.png", onHover: keeper.yearOne},
    ]
  },
  {
    id: nanoid(),
    teamName: [team.crashlots],
    manager: [manager.ariel],
    teamLogo: "../cha.png",
    rankings: [12, 1, 2, 5, 4, 3, 1, 6, 7, 9, 9, 4, 3, 8, 5, 2],
    initialFranchisePlayers: [
      "DJ Augustin, Raymond Felton, Gerald Wallace, Boris Diaw, Tyson Chandler, Nazr Mohammed",
      "Raymond Felton, Gerald Wallace, Boris Diaw, Tyrus Thomas",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Gerald Wallace",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Gerald Henderson",
        aquiredVia: "הרמת פרי אייג'נט",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Kemba Walker",
        aquiredVia: "קדנציה ראשונה - נלקח כסליפר רוקי בסיבוב האחרון",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Al Jefferson",
        aquiredVia: "טרייד על סליפר (ביל)",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Nicolas Batum",
        aquiredVia: "בחירה 13 בדראפט",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Kemba Walker",
        aquiredVia:
          "קדנציה שנייה - נרכש מחדש בעונת הפריצה תמורת החלפת בחירות עתידי",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Terry Rozier",
        aquiredVia: "בחירה 20 בדראפט",
        tenure: 4,
      },
      {
        id: nanoid(),
        name: "Miles Bridges",
        aquiredVia: "הורם כפרי אייג'נט",
        tenure: 1,
      },
    ],
    draftPositions: [2, 1, 10, 10, 7, 8, 9, 11, 5, 19, 3, 2, 8, 9, 3, 7],
    vetDraftPos: [6, 4, 3, 5, 10, 6, 7, 5, 1],
    headerColors: {
      backgroundColor: "#33BF80",
      color: "#FFD333",
    },
    currentKeepers: [
      {name: "Mark Williams", picUrl: "../mark-will.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Shai Gilgeous-Alexander", picUrl: "../sga.png", onHover: "קיפר חופשי"},
      {name: "Anthony Edwards", picUrl: "../antman.png", onHover: "קיפר חופשי"},
      {name: "Keyonte George", picUrl: "../keyonte.png", onHover: keeper.yearThree},
      {name: "Reed Sheppard", picUrl: "../sheppard.png", onHover: "סליפר סופמור"},
      {name: "Noah Clowney", picUrl: "../clowney.png", onHover: keeper.yearThree}
    ]
  },
  {
    id: nanoid(),
    teamName: [team.orlDunk, "Kind of MAGIC", "Go Mags"],
    manager: [
      manager.jDog,
      manager.alon,
      manager.zeev,
      manager.dror,
      manager.yoni,
    ],
    teamLogo: "../orl.png",
    rankings: [5, 9, 6, 8, 10, 8, 10, 8, 1, 2, 8, 8, 10, 5, 2, 4],
    initialFranchisePlayers: [
      "Jameer Nelson, Vince Carter, Mickael Pietrus, Rashard Lewis, Dwight Howard, Brandon Bass",
      "Jameer Nelson, Vince Carter, Rashard Lewis, Dwight Howard",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Dwight Howard",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Arron Afflalo",
        aquiredVia: "טרייד מינורי",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Victor Oladipo",
        aquiredVia: "נלקח כרוקי בבחירה רביעית של הסיבוב הראשון",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Serge Ibaka",
        aquiredVia: "טרייד",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Evan Fournier",
        aquiredVia: "טרייד",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Nikola Vucevic",
        aquiredVia: "בחירה 12 בדראפט",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Wendell Carter Jr",
        aquiredVia: "הורם מהווייברס בשלהי עונתו הרביעית",
        tenure: 2,
      },
    ],
    draftPositions: [13, 7, 3, 5, 4, 2, 4, 4, 3, 4, 10, 4, 4, 2, 7, 10],
    vetDraftPos: [10, 2, 6, 8, 4, 4, 10, 1, 8],
    headerColors: {
      backgroundColor: "#7005F7",
      color: "#FFA700",
    },
    currentKeepers: [
      {name: "Franz Wagner", picUrl: "../franz.png", onHover: keeper.franchise},
      {name: "Nikola Jokic", picUrl: "../jokic.png", onHover: "קיפר חופשי"},
      {name: "Domantas Sabonis", picUrl: "../sabonis.png", onHover: "קיפר חופשי"},
      {name: "Ausar Thompson", picUrl: "../ausar.png", onHover: keeper.yearThree},
      {name: "Cam Whitmore", picUrl: "../whitmore.png", onHover: keeper.yearThree},
      {name: "Adem Bona", picUrl: "../bona.png", onHover: keeper.yearTwo}
    ]
  },
  {
    id: nanoid(),
    teamName: [
      team.uthFlames,
      "Utah's Mormon",
      "Utah Jazz",
      "All That Jazz",
      "Bam Bam",
    ],
    manager: [manager.michael, manager.idan],
    teamLogo: "../uth.jpg",
    rankings: [11, 8, 4, 4, 11, 7, 4, 1, 1, 1, 9, 1, 5, 10, 11, 10], 
    initialFranchisePlayers: [
      "הפרנצ'ייז נוסד בסן אנטוניו",
      "Deron Williams, CJ Miles, Andrei Kirilenko, Paul Millsap",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Paul Millsap",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Al Jefferson",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Derrick Favors",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Gordon Hayward",
        aquiredVia: "טרייד",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Rudy Gobert",
        aquiredVia: "עסקת בלוקבאסטר",
        tenure: 5,
      },
      {
        id: nanoid(),
        name: "Jimmy Butler",
        aquiredVia: "טרייד על פול ג'ורג', שהושג תמורת קולינס הסליפר",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Bam Adebayo",
        aquiredVia: "טרייד על האליברטון ובהמשך צורף מחדש בבחירה 2",
        tenure: 1,
      },
    ],
    draftPositions: [11, 12, 3, 3, 8, 1, 5, 8, 11, 10, 11, 3, 2, 7, 2, 1],
    vetDraftPos: [4, 9, 9, 9, 5, 9, 9, 10, 11],
    headerColors: {
      backgroundColor: " #000003",
      color: "#F7F8F0",
    },
    currentKeepers: [
      {name: "Bam Adebayo", picUrl: "../bam.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Tyrese Maxey", picUrl: "../maxey.png", onHover: "קיפר חופשי"},
      {name: "Trey Murphy", picUrl: "../trey.png", onHover: "קיפר חופשי"},
      {name: "Brandon Miller", picUrl: "../miller.png", onHover: "סליפר עונה שלישית"},
      {name: "Toumani Camara", picUrl: "../camara.png", onHover: "סליפר עונה שלישית"},
      {name: "Matas Buzelis", picUrl: "../matas.png", onHover: "סליפר סופמור"}
    ]
  },
  {
    id: nanoid(),
    teamName: [team.chi88, "Chicago Kurves", "Chicago Gangstas", "Chicago Fire", "Chicago's on Fire"],
    manager: [manager.ran, manager.oded, manager.shiran],
    teamLogo: "../chi.jpg",
    rankings: [5, 7, 11, 11, 9, 9, 11, 3, 6, 3, 2, 9, 2, 4, 1, 3],
    initialFranchisePlayers: [
      "Derrick Rose, John Salmons, Loul Deng, Tyrus Thomas, Joakim Noah, Brad Miller",
      "Derrick Rose, Kirk Hinrich, Loul Deng, Joakim Noah",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Derrick Rose",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 2,
      },
      {
        id: nanoid(),
        name: "Joakim Noah",
        aquiredVia: "",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Jimmy Butler",
        aquiredVia: "טרייד",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Zach LaVine",
        aquiredVia: "בחירת סיבוב אחרון בעונה שהחמיץ",
        tenure: 6,
      },
    ],
    draftPositions: [4, 6, 5, 8, 1, 3, 2, 3, 9, 6, 9, 10, 3, 10, 8, 11],
    vetDraftPos: [9, 7, 4, 7, 8, 5, 8, 6, 9],
    headerColors: {
      backgroundColor: "#121F4A",
      color: "#B4272C"
    },
    currentKeepers: [
      {name: "Josh Giddey", picUrl: "../giddey.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Anthony Davis", picUrl: "../unibrow.png", onHover: "קיפר חופשי"},
      {name: "Karl Towns", picUrl: "../kat.png", onHover: "קיפר חופשי"},
      {name: "Walker Kessler", picUrl: "../kessler.png", onHover: keeper.yearFour},
      {name: "Stephon Castle", picUrl: "../castle.png", onHover: "סליפר סופמור"},
      {name: "Ives Missi", picUrl: "../missi.png", onHover: keeper.yearTwo},
    ]
  },
  {
    id: nanoid(),
    teamName: [
      team.gswRandolph,
      "GSWcurry",
      "San Francisco",
      "Golden Boys",
      "Golden state of shock",
    ],
    manager: [manager.sagi, manager.chauncey, manager.ilya, manager.rony, manager.shahar, manager.ben],
    teamLogo: "../gsw.png",
    rankings: [11, 5, 4, 1, 2, 1, 1, 8, 10, 6, 11, 10, 9, 6, 9, 11],
    initialFranchisePlayers: [
      "Stephen Curry, Monta Ellis, Corey Maggette, Anthony Randolph, Andris Biedrins, Anthony Morrow",
      "Stephen Curry, Monta Ellis, Anthony Randolph, Anthony Morrow",
    ],
    singleFranchisePlayer: [
      {
        id: nanoid(),
        name: "Monta Ellis",
        aquiredVia: "קיפר מעונת הג'נסיס",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Stephen Curry",
        aquiredVia: "קדנציה ראשונה - בעסקת בלוקבאסטר שנויה במחלוקת",
        tenure: 4,
      },
      {
        id: nanoid(),
        name: "Kevin Durant",
        aquiredVia: "טרייד על הפרנצ'ייז בלבוש אדם",
        tenure: 3,
      },
      {
        id: nanoid(),
        name: "Andrew Wiggins",
        aquiredVia: "",
        tenure: 1,
      },
      {
        id: nanoid(),
        name: "Stephen Curry",
        aquiredVia: "קדנציה שנייה -  באדיבות עידן והחלפת בחירה 2 בבחירה 11",
        tenure: 3,
      },
    ],
    draftPositions: [9, 2, 6, 7, 11, 10, 11, 10, 4, 7, 6, 1, 11, 3, 6, 6],
    vetDraftPos: [11, 1, 10, 2, 11, 10, 5, 2, 10],
    headerColors: {
      backgroundColor: "#F3B900",
      color: "#0F69FF",
    },
    currentKeepers: [
      {name: "Stephen Curry", picUrl: "../steph.png", onHover: "שחקן פרנצ'ייז"},
      {name: "Lauri Markkanen", picUrl: "../lauri.png", onHover: "קיפר חופשי"},
      {name: "Jalen Johnson", picUrl: "../jj.png", onHover: "קיפר חופשי"},
      {name: "Bennedict Mathurin", picUrl: "../mathurin.png", onHover: "שחקן השבחה"},
      {name: "Brandin Podziemski", picUrl: "../podz.png", onHover: "סליפר עונה שלישית"},
      {name: "Kel'el Ware", picUrl: "../ware.png", onHover: "סליפר סופמור"}
    ]
  },
];
